import { _Base } from "./_base";

export class Event extends _Base {
    raceId: string;
    scheduledTime: any;
    officialTime?: any;
    referees?: string[];
    locked?: any;
}